// src/Monitors.js
import React from 'react';
import { Grid, Card, Text, Divider } from '@mantine/core';

export default function Monitors({ modelId }) {
  return (
    <Grid gutter="md">
      {/* Bias Monitor */}
      <Grid.Col span={{ base: 12, sm: 6 }}>
        <Card
          withBorder
          radius="md"
          p="lg"
          style={{
            height: '100%',
            transition: 'all 0.2s ease-in-out',
            cursor: 'default'
          }}
          styles={{
            root: {
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 4px 12px rgba(0,0,0,0.04)'
              }
            }
          }}
        >
          <Text size="lg" fw={600} mb="xs">Bias Monitor</Text>
          <Divider my="sm" opacity={0.5} />
          <Text size="sm" c="dimmed" mb="md">
            Monitor model fairness and bias and their impact on risks
          </Text>
          <Text size="sm" c="dimmed" fs="italic" mt="xl">
            Coming soon
          </Text>
        </Card>
      </Grid.Col>

      {/* Performance Monitor */}
      <Grid.Col span={{ base: 12, sm: 6 }}>
        <Card
          withBorder
          radius="md"
          p="lg"
          style={{
            height: '100%',
            transition: 'all 0.2s ease-in-out',
            cursor: 'default'
          }}
          styles={{
            root: {
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 4px 12px rgba(0,0,0,0.04)'
              }
            }
          }}
        >
          <Text size="lg" fw={600} mb="xs">Performance Monitor</Text>
          <Divider my="sm" opacity={0.5} />
          <Text size="sm" c="dimmed" mb="md">
            Monitor model performance metrics and their impact on risks
          </Text>
          <Text size="sm" c="dimmed" fs="italic" mt="xl">
            Coming soon
          </Text>
        </Card>
      </Grid.Col>
    </Grid>
  );
}
